import { $ } from '../vendors/jquery';

class Header
{
    constructor( element ) 
    {
        this.element   = element;
        this.toggler   = this.element.find( '[data-element="header-toggler"]' );
        this.menu      = this.element.find( '[data-element="header-menu"]' );
        this.menuLinks = this.element.find( '[data-element="header-menu-link"]' );

        this.init();
    }

    init() 
    {
        this.toggler.on( 'click', this.onTogglerClick );
        this.addMenuEvents();
    }

    onTogglerClick() 
    {
        if ( $( this ).parent().hasClass( 'header__navigation--is-open' ) ) {
            $( 'body' ).removeClass( 'has-navigation-open' );
            $( this ).attr( 'aria-expanded', 'false' );
            $( this ).parent().removeClass( 'header__navigation--is-open' );
        } else {
            $( 'body' ).addClass( 'has-navigation-open' );
            $( this ).attr( 'aria-expanded', 'true' );
            $( this ).parent().addClass( 'header__navigation--is-open' );
        }
    }

    addMenuEvents() 
    {
        this.menuLinks.each( ( index, element ) => {
            $( element ).on( 'click', this.onMenuItemClick.bind( this, element ) );
        } );

        $( document ).on( 'click', ( event ) => {
            if ( false === this.element[0].contains( event.target ) ) {
                this.closeAllMenuItems();
            }
        } );

        // In case client wants back to switch to hover mode.
        // const isDesktop = window.matchMedia( '(min-width: 992px)' );

        // if ( isDesktop.matches ) {
        //     this.menuLinks.each( ( index, element ) => {
        //         $( element ).off( 'click' );
        //         $( element ).parent().on( 'mouseenter', this.openMenuItem.bind( this, element ) );
        //         $( element ).parent().on( 'mouseleave', this.closeMenuItem.bind( this, element ) );
        //     } );
        // } else {
        //     this.menuLinks.each( ( index, element ) => {
        //         $( element ).parent().off( 'mouseenter' );
        //         $( element ).parent().off( 'mouseleave' );
        //         $( element ).on( 'click', this.onMenuItemClick.bind( this, element ) );
        //     } );
        // }

        // isDesktop.addEventListener( 'change', ( event ) => {
        //     $( 'body' ).removeClass( 'has-navigation-open' );
        //     this.closeAllMenuItems();

        //     if ( event.matches ) {
        //         this.menuLinks.each( ( index, element ) => {
        //             $( element ).off( 'click' );
        //             $( element ).parent().on( 'mouseenter', this.openMenuItem.bind( this, element ) );
        //             $( element ).parent().on( 'mouseleave', this.closeMenuItem.bind( this, element ) );
        //         } );
        //     } else {
        //         this.menuLinks.each( ( index, element ) => {
        //             $( element ).parent().off( 'mouseenter' );
        //             $( element ).parent().off( 'mouseleave' );
        //             $( element ).on( 'click', this.onMenuItemClick.bind( this, element ) );
        //         } );
        //     }
        // } );
    }

    onMenuItemClick( element ) 
    {
        this.closeAllMenuItems( element );

        if ( $( element ).parent().hasClass( 'header__menu-item--is-open' ) ) {
            this.closeMenuItem( element );
        } else {
            this.openMenuItem( element );
        }

        return false;
    }

    openMenuItem( element ) 
    {
        $( element ).parent().addClass( 'header__menu-item--is-open' );
        $( element ).attr( 'aria-expanded', 'true' );
    }

    closeMenuItem( element ) 
    {
        $( element ).parent().removeClass( 'header__menu-item--is-open' );
        $( element ).attr( 'aria-expanded', 'false' );
    }

    closeAllMenuItems( excludeElement = null ) 
    {
        this.menuLinks.each( ( index, element ) => {
            if ( excludeElement === element ) {
                return;
            }

            this.closeMenuItem( element );
        } );
    }
}

const header = {
    init() {
        const headerElement = $( '[data-module="header"]' );

        if ( null !== headerElement ) {
            new Header( $( headerElement ) );
        }
    }
};

export default header;
